import Enrollments from '@/components/enrollments';
import Home from '@/components/home';
import Learners from '@/components/learners';
import Lessons from '@/components/lessons';
import Managers from '@/components/managers';
import Meetings from '@/components/meetings';
import Memberships from '@/components/memberships';
import Payments from '@/components/payments';
import Requests from '@/components/requests';
import Settings from '@/components/settings';
import Tasks from '@/components/tasks';
import Teachers from '@/components/teachers';

export default [
    {
        id: 'home',
        content: 'Главная',
        path: '/',
        exact: true,
        component: Home,
        icon: 'dashboard'
    },
    {
        id: 'tasks',
        content: 'Задачи',
        path: '/tasks',
        exact: false,
        component: Tasks,
        icon: 'checklist'
    },
    {
        id: 'chat',
        content: 'Чат',
        path: '/chat',
        exact: false,
        component: () => null,
        icon: 'chat'
    },
    {
        id: 'requests',
        content: 'Заявки',
        path: '/requests',
        exact: false,
        component: Requests,
        icon: 'contact_phone',
        permissions: ['all', 'requests']
    },
    {
        id: 'payments',
        content: 'Платежи',
        path: '/payments',
        exact: false,
        component: Payments,
        icon: 'payments',
        permissions: ['all', 'payments']
    },
    {
        id: 'enrollments',
        content: '',
        path: '/enrollments',
        exact: false,
        component: Enrollments,
        icon: '',
        hidden: true,
        permissions: ['all', 'enrollments']
    },
    {
        id: 'lessons',
        content: 'Уроки',
        path: '/lessons',
        exact: false,
        component: Lessons,
        icon: 'calendar_month',
        permissions: ['all', 'lessons']
    },
    {
        id: 'meetings',
        content: 'Встречи',
        path: '/meetings',
        exact: false,
        component: Meetings,
        icon: 'event',
        permissions: ['all', 'meetings']
    },
    {
        id: 'memberships',
        content: 'Абонементы',
        path: '/memberships',
        exact: false,
        component: Memberships,
        icon: 'confirmation_number',
        permissions: ['all', 'memberships']
    },
    {
        id: 'learners',
        content: 'Ученики',
        path: '/learners',
        exact: false,
        component: Learners,
        icon: 'groups',
        permissions: ['all', 'learners', 'users']
    },
    {
        id: 'teachers',
        content: 'Преподаватели',
        path: '/teachers',
        exact: false,
        component: Teachers,
        icon: 'face',
        permissions: ['all', 'teachers', 'users']
    },
    {
        id: 'managers',
        content: 'Менеджеры',
        path: '/managers',
        exact: false,
        component: Managers,
        icon: 'support_agent',
        permissions: ['all', 'managers', 'users']
    },
    {
        id: 'settings',
        content: 'Настройки',
        path: '/settings',
        exact: false,
        component: Settings,
        icon: 'settings',
        permissions: ['all', 'settings']
    }
];